import store from "@/store/index";
// 数据
const state = {
  // 头部按钮数据
  topBtns: [],
  topBtnActive: {}, // 所有按钮当前点击状态 obj对象
  drawingRadio: 1, // 绘制方式 1: 任意点 2: 模拟录入
  isOrthogonal: false, // 是否正交模式
  bottomBtnActive: [], // 右下角按钮当前点击状态 obj对象
  moveBoxId: 1, // 当前移动弹框盒子ID
  moveBoxActive: [], //当前可显示的盒子ID组
  fixationShow: false, // 固定盒子显隐
  moveFixationFrom: {
    distance: "",
    angle: "",
  }, // 固定盒子-移动表单
  EditRead: false, //当前是可编辑（false）还是只读（true）状态
  axisIsShow: false, //轴线（含命名）是否显示
  fontSize: 400,
  isDeleteMarker: false, //是否删除标记
  scaleShow: true, //是否显示比例尺
  ruleWidth: 40, //比例尺格数
  maxNum: 1000, //比例尺最大值
  isAxisNaming: false, //当前在轴线命名中
  isCopyFloor: false, //当前在复制楼层中
  isMoveOrCopy: false, //当前在移动或复制中
  numberAxis: "", //当前轴线命名
  letterAxis: "", //当前轴线命名
  numberAxis2: "", //当前轴线命名
};
// 同步方法
const mutations = {
  //设置比例尺格数
  setRuleWidth(state, n) {
    state.ruleWidth = n;
  },
  //设置比例尺最大值
  setMaxNum(state, n) {
    state.maxNum = n;
  },
  //设置是否显示比例尺
  setScaleShow(state, n) {
    state.scaleShow = n;
  },
  //设置是否删除标记
  setDeleteMarker(state, n) {
    state.isDeleteMarker = n;
  },

  //设置字体大小
  SET_FONTSIZE(state, item) {
    state.fontSize = item;
  },

  //设置轴线（含命名）是否显示
  SET_AXISISISSHOW(state, n) {
    state.axisIsShow = n;
  },
  //切换只读或可编辑状态
  CHANGE_EDITREAD: (state, n) => {
    state.EditRead = n;
    // state.EditRead = false;
  },
  // 切换页面时同步切换状态栏
  CHANGE_TOPBTNS: (state, arr) => {
    state.topBtns = arr;
    store.commit("platBtns/CLEAR_ALL");
  },
  // 改变不同按钮点击状态
  CHANGE_TOPBTNACT: (state, item) => {
    // 设置点击状态
    state.topBtnActive = state.topBtnActive.id === item.id ? {} : item;
    // 设置点击交互盒子
    // 3绘图 4直线轴网 5圆弧轴网 6轴线命名 7构件 8删除 9图层 10楼层
    const drawClose = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]; // 盒子汇总 - 增加相应盒子需在此也增加ID
    drawClose.forEach((i) => {
      // 根据不同判断 显示对应弹框并隐藏互斥弹框
      if (
        item.drawId !== undefined &&
        item.drawId === i &&
        state.topBtnActive.id
      ) {
        store.commit("platBtns/CHANGE_MOVEBOX", { id: i, bol: true });
      } else {
        store.commit("platBtns/CHANGE_MOVEBOX", { id: i, bol: false });
      }
    });
  },
  // 切换drawingRadio绘制方式
  CHANGE_DRAWINGRADIO(state, item) {
    state.drawingRadio = item;
  },
  // 是否正交模式
  CHANGE_ISORTHOGONAL(state, item) {
    state.isOrthogonal = item;
  },
  // 改变右下角按钮点击状态
  CHANGE_BOTTOMBTNACT(state, item) {
    // 更改bottomBtnActive按钮id
    if (state.bottomBtnActive.some((value) => value == item.id)) {
      state.bottomBtnActive = state.bottomBtnActive.filter(
        (value) => value !== item.id
      );
    } else {
      state.bottomBtnActive.push(item.id);
    }
  },
  // 改变不同的楼层状态
  CHANGE_TOPBUILD(state, id) {
    state.currentBuilding = id;
  },
  // 点击是否显示各种业务盒子 并存数组形式
  CHANGE_MOVEBOX(state, { id, bol, offset, isShow }) {
    if (!isShow) {
      rlAppObj._rlMx.MxFun.stopRunCommand();
    }
    if (bol) {
      state.moveBoxActive.includes(id) ? "" : state.moveBoxActive.push(id);
      // 把新增的弹框盒子层级设为最高
      store.commit("platBtns/CHANGE_MOVEBOXID", id);
    } else {
      // 去掉当前要显示的盒子弹框
      const newArray = state.moveBoxActive.filter((item) => item !== id);
      state.moveBoxActive = newArray;
      //当点击关闭的窗口id与高亮id一致时才能删除
      if (state.topBtnActive.drawId === id) {
        state.topBtnActive = {};
      }
    }
  },

  // 当前选中的移动弹框ID (设置层级使用)
  CHANGE_MOVEBOXID(state, id) {
    state.moveBoxId = id;
  },
  CLEAR_ALL(state) {
    state.topBtnActive = {}; // 所有按钮当前点击状态 obj对象
    state.bottomBtnActive = []; // 右下角按钮当前点击状态 obj对象
    state.moveBoxId = 1; // 当前移动弹框盒子ID
    state.moveBoxActive = []; //当前可显示的盒子ID组
  },
  // 设置选中值状态
  SET_TOPBTNACTIVE(state, obj) {
    const { key, value } = obj;
    state.topBtnActive[key] = value;
  },
  // 设置删除状态下选中的删除值
  SET_ACTIVEDEL(state, arr) {
    if (state.topBtnActive.id !== 404) return;
    state.topBtnActive.delArray = arr;
  },
  // 切换固定盒子显隐
  SET_FIXATIONSHOW(state, bol) {
    state.fixationShow = bol;
  },
  // 设置移动表单值
  SET_MOVEFIXATIONFROM(state, obj) {
    state.moveFixationFrom = obj
      ? obj
      : {
          distance: null,
          angle: null,
        };
  },
  //设置是否在轴线命名中
  SET_ISAXISNAMING(state, bol) {
    state.isAxisNaming = bol;
  },
  //设置是否在复制楼层中
  SET_ISCOPYFLOOR(state, bol) {
    state.isCopyFloor = bol;
  },
  //设置是否在移动或复制中
  SET_ISMOVEORCOPY(state, bol) {
    state.isMoveOrCopy = bol;
  },
  //设置当前轴线命名
  SET_NUMBERAXIS(state, str) {
    state.numberAxis = str;
  },
  //设置当前轴线命名
  SET_LETTERAXIS(state, str) {
    state.letterAxis = str;
  },
  //设置当前轴线命名
  SET_NUMBERAXIS2(state, str) {
    state.numberAxis2 = str;
  },
};
// 异步方法
const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
